<template>
  <transition name="modal-fade">
    <div v-if="state.show" class="modal-overlay" @click.self="cancel">
      <div class="modal-content">
        <h4>确认操作</h4>
        <p>{{ state.message }}</p>
        <div class="modal-actions">
          <button @click="cancel" class="btn-cancel">取消</button>
          <button @click="confirm" class="btn-confirm">确认</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import { confirmBus } from '../utils/confirmBus';

const state = computed(() => confirmBus.state.value);

const confirm = () => {
  if (state.value.onConfirm) {
    state.value.onConfirm();
  }
  confirmBus.hide();
};

const cancel = () => {
  if (state.value.onCancel) {
    state.value.onCancel();
  }
  confirmBus.hide();
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
}
.modal-content {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}
.modal-content h4 {
  margin-top: 0;
  font-size: 1.2em;
}
.modal-content p {
  color: #666;
  margin: 15px 0 25px;
}
.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}
.btn-cancel, .btn-confirm {
  padding: 10px 25px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  font-weight: 500;
}
.btn-cancel {
  background: #fff;
}
.btn-confirm {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter-from, .modal-fade-leave-to {
  opacity: 0;
}
</style>